import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography, CardMedia } from '@material-ui/core'
import gameScoreStyles from './gameScore.styles'
import DefaultOrgIcon from '../../assets/icons/DefaultOrgIcon'

const GameScore = ({ firstTeam, secondTeam }) => {
  const useStyles = makeStyles(gameScoreStyles)
  const classes = useStyles()
  const isFirstTeamHigher = firstTeam.teamScore > secondTeam.teamScore
  const isSecondTeamHigher = secondTeam.teamScore > firstTeam.teamScore

  return (
    <div className={classes.gameContainer}>
      <Typography noWrap variant='subtitle1' className={classes.teamNameLeft}>
        {firstTeam.teamName}
      </Typography>
      {firstTeam?.teamLogo ? (
        <CardMedia className={classes.teamLogo} image={firstTeam?.teamLogo} />
      ) : (
        <DefaultOrgIcon className={classes.teamLogo} />
      )}
      <div className={isFirstTeamHigher ? classes.highScore : classes.score}>
        <Typography variant='h6' className={classes.scoreNumber}>
          {firstTeam.teamScore}
        </Typography>
      </div>
      <div className={isSecondTeamHigher ? classes.highScore : classes.score}>
        <Typography variant='h6' className={classes.scoreNumber}>
          {secondTeam.teamScore}
        </Typography>
      </div>
      {secondTeam?.teamLogo ? (
        <CardMedia className={classes.teamLogo} image={secondTeam.teamLogo} />
      ) : (
        <DefaultOrgIcon className={classes.teamLogo} />
      )}
      <Typography noWrap variant='subtitle1' className={classes.teamNameRight}>
        {secondTeam.teamName}
      </Typography>
    </div>
  )
}

GameScore.propTypes = {
  firstTeam: PropTypes.shape({
    teamId: PropTypes.string.isRequired,
    teamLogo: PropTypes.string,
    teamName: PropTypes.string.isRequired,
    teamScore: PropTypes.number.isRequired,
  }).isRequired,
  secondTeam: PropTypes.shape({
    teamId: PropTypes.string.isRequired,
    teamLogo: PropTypes.string,
    teamName: PropTypes.string.isRequired,
    teamScore: PropTypes.number.isRequired,
  }).isRequired,
}

export default GameScore
